import React from 'react';
import { Text } from '@solvhealth/jigsaw';
import { useTranslation } from 'react-i18next';

type Props = {
  shouldShowUploadOptions: boolean;
  shouldShowExistingInsurance: boolean;
  shouldShowUploadInsurance: boolean;
  hasInsuranceProfiles: boolean;
};

const PaymentSectionSubheader = (props: Props) => {
  const { t } = useTranslation(['paperwork', 'common']);
  const {
    shouldShowUploadOptions,
    shouldShowExistingInsurance,
    shouldShowUploadInsurance,
    hasInsuranceProfiles,
  } = props;
  if (shouldShowUploadOptions && !shouldShowExistingInsurance) {
    return <Text variant="h4">{t('paperwork:payment.chooseInsuranceMethodSubTitle')}</Text>;
  }
  if (shouldShowExistingInsurance && hasInsuranceProfiles) {
    return <Text variant="h4">{t('paperwork:payment.selectExistingInsuranceMethodSubTitle')}</Text>;
  }
  if (shouldShowUploadInsurance) {
    return <Text variant="h4">{t('paperwork:payment.addNewInsuranceMethodSubTitle')}</Text>;
  }
  return null;
};

export default PaymentSectionSubheader;
